import { Maybe } from "src/types.g";

export const getDuplicateInstanceName = (
  originalName: string | Maybe<string>
) => {
  return `Copy of ${originalName}`;
};
